/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import RemoveMethod from './remove-method';
import PopupHeader from '../../common/PopupHeader';
import { ErrorMessage } from '../../common/Message';
import { executeHttpRequest } from '../../../epics/api';

class AddPaymentContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
        };
    }

    handleSubmit = payload =>
        executeHttpRequest(
            `clients/${this.props.basicInfo.id}/payment-methods/`,
            'POST',
            payload,
        );

    handleRemove = payload =>
        executeHttpRequest(
            `clients/${this.props.basicInfo.id}/payment-methods/${this.props.paymentMethod.id}/`,
            'DELETE',
            payload,
        );

    handleError = error => {
        this.setState({
            error,
        });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            this.state.error &&
            (!prevState.error || prevState.error != this.state.error)
        ) {
            const that = this;
            setTimeout(() => {
                that.errorDom.scrollIntoView({
                    block: 'start',
                    behavior: 'smooth',
                });
            }, 10);
        }
    }

    onDismiss = () => {
        this.setState({
            error: null,
        });
        this.props.onRequestClose();
    };

    render() {
        const { isOpen, mode } = this.props;

        const title =
            mode == 'remove_method'
                ? 'Remove this payment method?'
                : mode;
        return (
            <Modal
                isOpen={isOpen}
                onRequestClose={this.onDismiss}
                contentLabel="Add Card Modal"
                className="add-payment-modal"
            >
                <div className="add-payment-container ">
                    <PopupHeader
                        title={`${title}`}
                        onDismiss={this.onDismiss}
                    />
                    {mode == 'remove_method' && (
                        <RemoveMethod
                            onDismiss={this.onDismiss}
                            handleError={this.handleError}
                            handleSubmit={this.handleRemove}
                            paymentMethod={this.props.paymentMethod}
                        />
                    )}
                </div>
                <div ref={el => {this.errorDom = el}}>
                    {this.state.error ? (
                        <ErrorMessage message={this.state.error} />
                    ) : null}
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    basicInfo: state.clientData.basicInfo,
});

export default connect(mapStateToProps)(AddPaymentContainer);
